export default [
  {
    path: '',
    name: 'consume_records',
    component: () => import('./List'),
  },
]
